import { requestHandler } from "./baseApi";

export const addUserToGroup = async ({ groupName, email, sub }: { groupName: string; email: string; sub: string }) => {
  const params = {
    groupname: groupName,
    username: sub,
    email: email,
  };

  return await requestHandler({
    method: "POST",
    url_extension: "cognito/users/addtogroup",
    params,
  });
};

export const addOrgUserType = async (values: Record<string, any>) => {
  return await requestHandler({
    method: "POST",
    url_extension: "my-company/addOrgUserType",
    params: values,
  });
};
